import { render, staticRenderFns } from "./MailTemplateLayoutUpdate.vue?vue&type=template&id=02e6be5b&scoped=true"
import script from "./MailTemplateLayoutUpdate.vue?vue&type=script&lang=js"
export * from "./MailTemplateLayoutUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e6be5b",
  null
  
)

export default component.exports